const manageBodyOverflow = (displayState) => {
  const { body } = global.document;

  if (body) {
    if (displayState) body.style.setProperty('overflow', 'hidden');
    else body.style.setProperty('overflow', 'auto');
  }
};

export default manageBodyOverflow;
